import { Component } from '@angular/core';

@Component({
  selector: 'avs-error-engine-overview',
  standalone: false,

  templateUrl: './error-engine-overview.component.html',
  styleUrl: './error-engine-overview.component.css'
})
export class ErrorEngineOverviewComponent {

}
